import { Container } from "@mui/material";
import React from "react";
import { PaginaJosemarIconoIndex } from "../../../components/Admin/Nosotros/Icono/IndexIcono";

export const PaginaIconoJosemarAdmin = () => {
    return(
        <Container maxWidth='lg'>
            <PaginaJosemarIconoIndex/>
        </Container>
    )
}